import { render } from "./Student.vue?vue&type=template&id=11abaeaa&scoped=true&ts=true"
import script from "./Student.vue?vue&type=script&lang=ts"
export * from "./Student.vue?vue&type=script&lang=ts"

import "./Student.vue?vue&type=style&index=0&id=11abaeaa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11abaeaa"]])

export default __exports__